import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Card from '../../components/uielements/cards';
import Avatar from '../../components/uielements/avatars';
import { transition } from '../../settings/style-util';

export default {
  Card: styled(Card)`
    display: flex;  
    flex-direction: column;
    width: 100%;
    height: fit-content;
    margin: 10px 0;
    padding: 10px;
    cursor: pointer;
  `,
  MetaSection: styled.div`
    flex: 1;
    display: flex;
    align-items: center;
  `,
  MetaText: styled.div`
    display: flex;    
    flex-direction: column;
    align-items: flex-start;
  `,
  Content: styled.div`
    flex: 4;
  `,
  Title: styled(Typography)`
    color: #0000008a;
    font-size: 0.9rem;
  `,
  Date: styled(Typography)`
    color: #0000008a;
    font-size: 0.8rem;
  `,
  Message: styled(Typography)`
    color: #424242;
    font-size: 1.1rem;
    margin: 10px 0;
    margin-bottom: 0;
    line-height: 1.6em;
    max-height: 4.8em;
    overflow: hidden;
  `,
  Avatar: styled(Avatar)`
    margin-right: 10px;
    width: 35px;
    height: 35px;

    color: #ffffff;
    background-color: ${props => props.compulsory ? '#f50057' : '#00b6f9'};
    .material-icons {
      font-size: 28px;
      color: #fff;
      margin-right: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      ${transition()};
    }
  `,
}


// WEBPACK FOOTER //
// ./src/containers/Topbar/notificationStyle.js